<template>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title">
          <i class="fas fa-cog mr-2"></i>
          <span class="font-weight-bold">Multi-Factor Authentication</span>
        </p>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid py-3">
          <div class="row justify-content-center mb-3">
            <div class="col-12 text-center">
              <p class="mb-2">
                Enter the 6-digit code from your authenticator app to continue.
              </p>
            </div>
          </div>
          <div class="row justify-content-center mb-2">
            <div class="col-12 col-md-8 col-lg-6">
              <div class="input-group mb-2">
                <input
                  v-model="code"
                  class="form-control text-center"
                  maxlength="6"
                  placeholder="000000"
                  autofocus
                  @keyup.enter="onSubmit"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-dark btn-sm"
                    @click="onSubmit"
                    :disabled="pending"
                  >
                    <span v-if="!pending">Verify</span>
                    <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
p.modal-title i,
p.modal-title span {
  opacity: 0.7;
}
button {
  min-width: 80px;
}
</style>

<script>
import { Api } from "../factory";
import { mfa } from "../component";
import { alert } from "../service";

export default {
  get components() {
    return {
      mfa
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
      validator: o =>
        typeof o.methods == `object` &&
        typeof o.methods.success == `function` &&
        typeof o.methods.error == `function`
    }
  },
  data() {
    return {
      code: ``,
      error: ``,
      pending: false
    };
  },
  methods: {
    async onSubmit() {
      if (!this.code || this.code.length !== 6) {
        this.error = `Please enter a valid 6-digit code.`;
        alert.error(this.error, 3e3);;
        return;
      }
      this.pending = true;
      this.error = ``;
      try {
        var resp = await Api.post( `users?_action=login`, { mfa: { code: this.code } });
        var { mfaToken } = resp.data;
        if (this.data.methods.success)
          this.data.methods.success(mfaToken);

      } catch (e) {
        this.error = e.message || `Invalid code.`;
        if (this.data.methods.error)
           this.data.methods.error()
      } finally {
        this.pending = false;
      }
    }
  }
};
</script>
